import { shellNavPathPermission } from './shellModulePermissions.ts';
import { SHELL_SYNC_NAV_HREF, shellNavPathname } from './shellNavRoutes.ts';

/** Shell navigation item (bottom bar / rail + home cards). */
export interface ShellNavItem {
  path: string;
  /** Short label in the navigation bar. */
  label: string;
  /** One-line subtitle under the title on the home card. */
  description: string;
  /** Emoji on home cards; the rail uses SVGs in `SidebarComponent`. */
  iconEmoji?: string;
}

export const SHELL_NAV_ITEMS: readonly ShellNavItem[] = [
  {
    path: '/',
    label: 'Inicio',
    description: 'Punto de partida: accesos rápidos y resumen de la app.',
  },
  {
    path: '/puntos-entrega',
    label: 'Entregas',
    description: 'Registrar y consultar puntos de entrega de bonos y participantes en campo.',
    iconEmoji: '🧾',
  },
  {
    path: '/redencion-bono',
    label: 'Redención bono',
    description: 'Gestionar el proceso de redención del bono según las reglas del programa.',
    iconEmoji: '📦',
  },
  {
    path: SHELL_SYNC_NAV_HREF,
    label: 'Sincronización',
    description:
      'Sincronizar registros, revisar almacenamiento local y actualizar la aplicación en el dispositivo.',
    iconEmoji: '💾',
  },
  {
    path: '/observabilidad',
    label: 'Observabilidad',
    description:
      'Consultar logs, trazas, eventos y métricas persistidas en SQLite (solo perfil administrador).',
    iconEmoji: '📈',
  },
];

/**
 * Same rules as the nav bar: until permissions resolve, only routes without a module gate;
 * afterward filter by `permissionSet`.
 */
export function getVisibleShellNavItems(permissionSet: ReadonlySet<string> | null): readonly ShellNavItem[] {
  return SHELL_NAV_ITEMS.filter((item) => {
    if (permissionSet === null) {
      return shellNavPathPermission(shellNavPathname(item.path)) === undefined;
    }
    const need = shellNavPathPermission(shellNavPathname(item.path));
    return need === undefined || permissionSet.has(need);
  });
}
